import axios from "axios";
import { Message } from "element-ui";

axios.interceptors.request.use(
    function (config) {
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    function (res) {
        if (res.config.responseType === 'blob') {
            return res;
        }
        return res.data;
    },
    function (error) {
        console.log(error);
        if (error.response && error.response.status === 401) {
            errorMsgTips("登录已失效，请重新登录");
            
        } else if (error.response && error.response.status === 403) {
            errorMsgTips("权限不足，请联系管理员！");
        } else {
            errorMsgTips(error.response ? (error.response.data.message || error.response.data.msg) : error.message);
        }
        return Promise.reject(error.response ? error.response.data : error);
    }
);

function errorMsgTips(message) {
    Message.error(message || "查询失败");
}

export const axiosResponse = (http) => {
    return new Promise((resolve) => {
        http.then((result) => {
            const resultResponse = {
                code: result.code,
                success: true,
                data: result.data,
                message: result.message,
                total: result.total
            };
            resolve(resultResponse);
        }).catch(error => {
            const errorResponse = {
                code: error.code,
                success: false,
                data: error,
            };
            resolve(errorResponse);
        });
    });
};

export default axios;